var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _rect5, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 20,
    viewBox: "0 0 100 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_3068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85416 18.3333L6.20832 12.4792L1.66666 8.54167L7.66666 8.02083L9.99999 2.5L12.3333 8.02083L18.3333 8.54167L13.7917 12.4792L15.1458 18.3333L9.99999 15.2292L4.85416 18.3333Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15_3068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8542 18.3333L26.2083 12.4792L21.6667 8.54167L27.6667 8.02083L30 2.5L32.3333 8.02083L38.3333 8.54167L33.7917 12.4792L35.1458 18.3333L30 15.2292L24.8542 18.3333Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15_3068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8542 18.3333L46.2083 12.4792L41.6667 8.54167L47.6667 8.02083L50 2.5L52.3333 8.02083L58.3333 8.54167L53.7917 12.4792L55.1458 18.3333L50 15.2292L44.8542 18.3333Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15_3068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 20,
    height: 20
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8542 18.3333L66.2083 12.4792L61.6667 8.54167L67.6667 8.02083L70 2.5L72.3333 8.02083L78.3333 8.54167L73.7917 12.4792L75.1458 18.3333L70 15.2292L64.8542 18.3333Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_15_3068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 0,
    width: 20,
    height: 20
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_15_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8542 18.3333L86.2083 12.4792L81.6667 8.54167L87.6667 8.02083L90 2.5L92.3333 8.02083L98.3333 8.54167L93.7917 12.4792L95.1458 18.3333L90 15.2292L84.8542 18.3333Z",
    fill: "#FFDF00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating5);
export default __webpack_public_path__ + "static/media/rating-5.d7837bea65b3a2fbd10c7949efac0345.svg";
export { ForwardRef as ReactComponent };